export default __webpack_public_path__ + "static/media/yagasuri.af701e2b.jpg";